import { Router, RouteComponentProps } from "@reach/router";
import React from 'react';
import AssessmentList from './assessment-list';
import './index.less'

const AssessmentDetails: React.FC<RouteComponentProps> = () => (
  <Router>
    <AssessmentList path="/" />
  </Router>
);
export default AssessmentDetails;
